export default __webpack_public_path__ + "static/media/mail.1902402e.png";